import { createAction } from '@reduxjs/toolkit';

export const FETCH_MESSAGES_ACTION_TYPE = 'saga/fetchMessages';
export const fetchMessagesAction = createAction(FETCH_MESSAGES_ACTION_TYPE);
